import React from 'react'
import { Link, useLocation } from 'react-router-dom'
import styled from 'styled-components'

const A = styled(Link)`
    text-decoration: none;
    color: black;
    border-radius: 50%;
    background-color: ${props => props.selected ? 'rgba(0, 0, 0, 0.08)' : null};
    width: 34px;
    height: 34px;
    display: flex;
    justify-content: center;
    align-items: center;
    font-size: 0.875rem;
    &:hover {
        text-decoration: none;
        background-color: rgba(0, 0, 0, 0.04);
        color: black;
    }
`

const FlexContainer = styled.div`
    display: flex;
    width: 420px;
    justify-content: center;
`

const FlexRow = styled.div`
    display: flex;
    align-items: center;
    gap: 6px;
`

const Inactive = styled.div`
    color: grey;
`

export default function PaginationLink(props) {
    const { page, pageSize, total, handlePageChange } = props
    const location = useLocation();
    const incomingPath = location.pathname.split('/')
    const path = isNaN(parseInt(incomingPath[incomingPath.length - 1])) ?
        incomingPath.join('/') :
        incomingPath.slice(0, -1).join('/')
    const lastPage = total === 10000 ? Math.floor(total / pageSize) : Math.ceil(total / pageSize)

    function PageLink({ page, label }) {
        const child = label || page
        return !!handlePageChange ? (
            <A
                to={incomingPath}
                onClick={(e) => {
                    e.preventDefault()
                    handlePageChange(page)
                }}
                selected={page === props.page}
            >
                {child}
            </A>
        ) : (
            <A to={`${path}/${page}`} selected={page === props.page}>{child}</A>
        )
    }

    return (
        <FlexContainer>
            {lastPage <= 5 ? (
                <FlexRow>
                    {page > 1 ? (
                        <PageLink page={page - 1} label='<' />
                    ) : (
                        <Inactive>{`<`}</Inactive>
                    )}
                    <PageLink page={1} />
                    {total > pageSize && <PageLink page={2} />}
                    {total > pageSize * 2 && <PageLink page={3} />}
                    {total > pageSize * 3 && <PageLink page={4} />}
                    {total > pageSize * 4 && <PageLink page={5} />}
                    {page < lastPage ? (
                        <PageLink page={page + 1} label='>' />
                    ) : (
                        <Inactive>{`>`}</Inactive>
                    )}
                </FlexRow>
            ) : (
                <FlexRow>
                    {page > 1 ? (
                        <PageLink page={page - 1} label='<' />
                    ) : (
                        <Inactive>{`<`}</Inactive>
                    )}
                    <PageLink page={1} />
                    {page < 5 ? (
                        <>
                            <PageLink page={2} />
                            <PageLink page={3} />
                            <PageLink page={4} />
                            <PageLink page={5} />
                            <Inactive>...</Inactive>
                        </>
                    ) :
                        page > lastPage - 4 ? (
                            <>
                                <Inactive>...</Inactive>
                                <PageLink page={lastPage - 4} />
                                <PageLink page={lastPage - 3} />
                                <PageLink page={lastPage - 2} />
                                <PageLink page={lastPage - 1} />
                            </>
                        ) : (
                            <>
                                <Inactive>...</Inactive>
                                <PageLink page={page - 1} />
                                <PageLink page={page} />
                                <PageLink page={page + 1} />
                                <Inactive>...</Inactive>
                            </>
                        )}
                    {isNaN(lastPage) ? (
                        <PageLink page={null} />
                    ) : (
                        <PageLink page={lastPage} />
                    )}

                    {page < lastPage ? (
                        <PageLink page={page + 1} label='>' />
                    ) : (
                        <Inactive>{`>`}</Inactive>
                    )}
                </FlexRow>
            )}
        </FlexContainer>
    )
}
